import axios from 'axios';
// import { showWarning } from './notificationService'; // Adjust path as needed

export const getAllJobPostings = async () => {
  try {
    const response = await axios.get('/recruitment/job-postings');
    return response.data; // Backend returns array directly
  } catch (error) {
    console.error('Error fetching job postings:', error.message);
    return [];
  }
};

export const getJobPostingById = async (id) => {
  try {
    const response = await axios.get(`/recruitment/job-postings/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching job posting:', error.message);
    return null;
  }
};

export const createJobPosting = async (jobData) => {
  try {
    const response = await axios.post('/recruitment/job-postings', jobData);
    return response.data;
  } catch (error) {
    console.error('Error creating job posting:', error.message);
    return null;
  }
};

export const updateJobPosting = async (id, jobData) => {
  try {
    const response = await axios.put(`/recruitment/job-postings/${id}`, jobData);
    return response.data;
  } catch (error) {
    console.error('Error updating job posting:', error.message);
    return null;
  }
};

export const deleteJobPosting = async (id) => {
  try {
    await axios.delete(`/recruitment/job-postings/${id}`);
    return true;
  } catch (error) {
    console.error('Error deleting job posting:', error.message);
    return false;
  }
};

export const fetchSearchJobPostings = async ({ setLoading, title, department, postedDate }) => {
  try {
    setLoading(true);
    const response = await axios.get(`/recruitment/job-postings/search?title=${title}&department=${department}&postedDate=${postedDate}`);
    setLoading(false);
    return response.data; // Backend returns array directly
  } catch (error) {
    setLoading(false);
    console.error('Error searching job postings:', error.message);
    return [];
  }
};

export const submitApplication = async (formData) => {
  try {
        console.log('Sending FormData:', [...formData.entries()]); // Debug log

    const response = await axios.post('/recruitment/applications', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting application:', error.message);
    throw error; // Re-throw to handle in frontend
  }
};

export const getAllApplications = async () => {
  try {
    const response = await axios.get('/recruitment/applications');
    return response.data;
  } catch (error) {
    console.error('Error fetching applications:', error.message);
    return [];
  }
};

export const getApplicationById = async (id) => {
  try {
    const response = await axios.get(`/recruitment/applications/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching application:', error.message);
    return null;
  }
};

export const updateApplicationStatus = async (id, status) => {
  try {
    const response = await axios.put(`/recruitment/applications/${id}`, { status });
    return response.data;
  } catch (error) {
    console.error('Error updating application status:', error.message);
    return null;
  }
};

export const deleteApplication = async (id) => {
  try {
    await axios.delete(`/recruitment/applications/${id}`);
    return true;
  } catch (error) {
    console.error('Error deleting application:', error.message);
    return false;
  }
};


export const searchApplications = async ({ jobTitle, candidateName, status }) => {
  try {
    const params = {};
    if (jobTitle) params.jobTitle = jobTitle;
    if (candidateName) params.candidateName = candidateName;
    if (status) params.status = status;
    const response = await axios.get('/recruitment/applications/search', { params });
    return response.data;
  } catch (error) {
    console.error('Error searching applications:', error.message);
    return [];
  }
};

export const matchQualifications = async (applicationId, jobId) => {
  try {
    const response = await axios.get(`/recruitment/applications/${applicationId}/match/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Error matching qualifications:', error.message);
    throw error;
  }
};

export const scheduleInterview = async (interviewData) => {
  try {
    const response = await axios.post('/recruitment/interviews', interviewData);
    return response.data;
  } catch (error) {
    console.error('Error scheduling interview:', error.message);
    throw error;
  }
};

export const getAllInterviews = async () => {
  try {
    const response = await axios.get('/recruitment/interviews');
    return response.data;
  } catch (error) {
    console.error('Error fetching interviews:', error.message);
    return [];
  }
};

export const getInterviewById = async (id) => {
  try {
    const response = await axios.get(`/recruitment/interviews/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching interview:', error.message);
    return null;
  }
};

export const updateInterview = async (id, interviewData) => {
  try {
    const response = await axios.put(`/recruitment/interviews/${id}`, interviewData);
    return response.data;
  } catch (error) {
    console.error('Error updating interview:', error.message);
    throw error;
  }
};

export const deleteInterview = async (id) => {
  try {
    await axios.delete(`/recruitment/interviews/${id}`);
    return true;
  } catch (error) {
    console.error('Error deleting interview:', error.message);
    return false;
  }
};

export const getResumeDetails = async (id) => {
  try {
    const response = await axios.get(`/recruitment/applications/${id}/resume-details`);
    return response.data;
  } catch (error) {
    console.error('Error fetching  details:', error.message);
    throw error;
  }
};


export const generateOfferLetter = async (offerData) => {
  try {
    const response = await axios.post('/recruitment/offer-letters', offerData);
    return response.data;
  } catch (error) {
    console.error('Error generating:', error.message);
    return false;
  }
};

export const downloadOfferLetter = async (id) => {
  try {
const response = await axios.get(`/recruitment/offer-letters/${id}/download`, {
      responseType: 'blob',
    });    return response.data;
  } catch (error) {
    console.error('Error download letter:', error.message);
    throw error;
  }
};

export const sendOfferLetterEmail = async (id) => {
  try {
    const response = await axios.post(`/recruitment/offer-letters/${id}/send-email`);
    return response.data;
  } catch (error) {
 console.error('Error send:', error.message);
    return false;  }
};


export const getAllTemplates = async () => {
  try {
    const response = await axios.get('/recruitment/template');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch templates');
  }
};

// Create a new template
export const createTemplate = async (formData) => {
  try {
    const response = await axios.post('/recruitment/template', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create template');
  }
};

// Update a template
export const updateTemplate = async (id, formData) => {
  try {
    const response = await axios.put(`/recruitment/template/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update template');
  }
};

// Set active template
export const setActiveTemplate = async (id) => {
  try {
    const response = await axios.put(`/recruitment/template/${id}/activate`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to set active template');
  }
};